
import { mapState } from "vuex";
import ResponsiveDialog from "./responsive-dialog.vue";
export default {
  components: { ResponsiveDialog },
  props: {
    dialog: false,
    persistent: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState("order", ["restaurantDetails"])
  },
  methods: {
    handleExploreMenu() {
      this.$router.push("/order/menu");
      this.$emit("close-dialog");
    }
  }
};
